import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from '@/pages/home/components/HeroSection';
import SocialMatrix from '@/pages/home/components/SocialMatrix';
import UpdateFeed from '@/pages/home/components/UpdateFeed';
import HotTalk from '@/pages/home/components/HotTalk';
import UpdateTimeline from '@/pages/home/components/UpdateTimeline';
import FollowCta from '@/pages/home/components/FollowCta';
import FaqSection from '@/pages/home/components/FaqSection';

export default function Home() {
  return (
    <div className="w-full overflow-x-hidden bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <SocialMatrix />
        <UpdateFeed />
        <HotTalk />
        <UpdateTimeline />
        <FollowCta />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}